module.exports = __webpack_public_path__ + "img/ufton_b2.ec1a5989.jpg";